<template>
  <v-dialog :value="true" max-width="400" content-class="rounded-xl" @click:outside="cancel">
    <v-card>
      <v-card-title>
        <vs-heading>Delete Signature</vs-heading>
      </v-card-title>

      <v-card-text class="pb-2">
        <vs-text>Are you sure you want to delete this signature?</vs-text>
      </v-card-text>

      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <vs-button label="Cancel" type="secondary" class="mr-2" @click="cancel" />
        <vs-button label="Ok" @click="confirm" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import VsHeading from '@/components/vision/VsHeading.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'

const emits = defineEmits<{
  (event: 'close')
  (event: 'confirm')
}>()

const cancel = () => {
  emits('close')
}

const confirm = () => {
  emits('confirm')
}
</script>
